import React, { useCallback, useEffect, useState } from "react";
import Table from "../../../components/Table/Table";
import Box from "../../../components/Box";
import Label from "../../../components/Label";
import Searchbar from "../../../components/Searchbar";
import links from "../../../constants/customerFilters.json";
import DefaultModal from "../../../components/DefaultModal/DefaultModal";
import ProfileModal from "./ProfileModal";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCities,
  fetchCustomerInfoList,
  sendMemberReminders,
  setMemberDetailsVisible,
  fetchSampleExcel,
} from "../../Admin/adminAction";
import Button from "../../../components/Buttons";
import { showNotification } from "../../../util/Utility";
import PaginationV2 from "../../../components/Pagination/PaginationV2";
import CheckboxMenu from "./CheckBoxMenu";
import CheckBoxSortBy from "./CheckBoxSortBy";
import styled from "styled-components";
import truncate from "lodash/truncate";
import { useTranslation } from "react-i18next";
import { Tooltip } from "antd";
import { Modal } from "antd";
import { capitalizeFirstLetter } from "../../../util/Utility";
import download from "../../../assets/images/download-white-icon.svg";
import { components } from "react-select";
import dropdownIcon from "../../../assets/images/dropdown-primary-icon.svg";
import Select from "react-select";
import {
  fetchMemberInfoList,
  updatePageForMemberInfoList,
} from "../../../redux/UserReducer/userAction";
import { callApiV2 } from "../../../util/apiCaller";
import { csvDoUrl } from "../../../app.config";
import { display } from "styled-system";
import CheckBoxFilterAndSearch from "./CheckBoxFilterAndSearch";

function MemberTable({ isFilterBlocked, blockedView, infoPage = true }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const bizIndustryLinks = links;
  const userType = localStorage.getItem("user_type");

  const [qtext, setValue] = useState("");
  const [pageConfig, setPageConfig] = useState([]);
  const [columns, setColumns] = useState([]);
  const currentYear = new Date().getFullYear();
  const previousYear = currentYear - 1;

  const yearOptions = [
    { value: currentYear, label: currentYear.toString() },
    { value: previousYear, label: previousYear.toString() },
  ];

  const defaultYearOption = yearOptions.find((y) => y.value === currentYear);
  const [selectedYear, setSelectedYear] = useState(defaultYearOption);

  const BoxContainer = styled(Box)`
    background: #f5f5f5;
    width: 220px;
    padding: 10px;
    border-radius: 8px;
    margin-left: 10px;
    height: 38px;
  `;

  const TemplateTableData = [
    {
      heading: t("S.No."),
    },
    {
      heading: columns?.showMosqueName ? t("Mosque Name") : t("User Name"),
    },
    {
      heading:
        columns?.showMosqueName && columns?.showUsername ? t("User Name") : "",
    },
    {
      heading: t("Jan"),
    },
    {
      heading: t("Feb"),
    },
    {
      heading: t("Mar"),
    },
    {
      heading: t("Apr"),
    },
    {
      heading: t("May"),
    },
    {
      heading: t("Jun"),
    },
    {
      heading: t("Jul"),
    },
    {
      heading: t("Aug"),
    },
    {
      heading: t("Sep"),
    },
    {
      heading: t("Oct"),
    },
    {
      heading: t("Nov"),
    },
    {
      heading: t("Dec"),
    },
  ];

  const [isMemberModalVisible, setIsMemberModalVisible] = useState(false);
  const [entitiesList, setEntitiesList] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [infoModal, setInfoModal] = useState(false);
  const [filters, setFilters] = useState({});
  const [mosqueFilters, setMosqueFilters] = useState({});

  console.log(" filtsers :", filters);

  const activeEntity = useSelector((state) => state.adminReducer.activeEntity);
  const memberList = useSelector(
    (state) => state.userReducer.memberInfo?.memberInfoList,
  );
  const pages = useSelector((state) => state?.appReducer?.pages);
  const [sortedMemberList, setSortedMemberList] = useState(memberList);

  const isFetching = useSelector(
    (state) => state.userReducer?.memberInfo?.isFetching,
  );
  const is_sending_reminder = useSelector(
    (state) => state.adminReducer.is_sending_reminder,
  );
  const memberInfoCount = useSelector(
    (state) => state.userReducer.memberInfo?.memberInfoCount,
  );
  const customerPageNum = useSelector(
    (state) => state.userReducer?.memberInfo?.currentPage,
  );
  const customerPageSize = useSelector(
    (state) => state.userReducer?.memberInfo?.pageSize,
  );

  const [selectedUsers, setSelectedUser] = useState({});
  const [isCheckedActive, setIsCheckedActive] = useState(true);
  const [isDeactivated, setIsDeactivated] = useState(false);
  const [isMonthly, setIsMonthly] = useState();
  const [isYearly, setIsYearly] = useState();
  const [paymentStatus, setpaymentStatus] = useState(false);
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  const [isSearch, setIsSearch] = useState();

  const getEntityListNames = () => {
    const names = entitiesList.map((entity) => ({
      label: entity.name,
      value: entity._id,
    }));
    return names;
  };

  useEffect(() => {
    dispatch(updatePageForMemberInfoList(1));
    dispatch(
      fetchMemberInfoList({
        entity_id: activeEntity?._id,
        filters,
        isDeactivated: isDeactivated,
        pageSize: customerPageSize,
        pageNum: customerPageNum,
        year: selectedYear.value,
      }),
    );
  }, [dispatch, activeEntity, filters, isDeactivated, selectedYear?.value]);

  useEffect(() => {
    setSortedMemberList(memberList);
  }, [memberList]);

  useEffect(() => {
    if (pages?.length > 0) {
      let memberConfig = pages?.find((item) => item?.label === "member_info");
      setPageConfig(memberConfig);
      setColumns(memberConfig?.columns[0]);
    }
  }, [pages]);

  function refetchCustomerList() {
    const filteredDetails = { ...filters, isApproved: true };
    dispatch(
      fetchMemberInfoList({
        entity_id: activeEntity?._id || "",
        pageSize: customerPageSize,
        pageNum: customerPageNum,
        filters: filteredDetails,
        isDeactivated: isDeactivated,
        year: selectedYear.value,
      }),
    );
  }
  const getStatus = () => {
    if (!!filters?.length) {
      return filters.find((item) => item?.status === "INACTIVE");
    }
  };

  useEffect(() => {
    getStatus();
    const newData = { heading: "All" };
    if (!!getStatus() && getStatus()?.status === "INACTIVE") {
      TemplateTableData[0] = newData;
    } else {
      TemplateTableData[0] = { heading: "S.No." };
    }
  }, [filters]);

  const onPageChange = (pageNum) => {
    const filteredDetails = { ...filters, isApproved: true };
    dispatch(updatePageForMemberInfoList(pageNum));
    dispatch(
      fetchMemberInfoList({
        entity_id: activeEntity?._id,
        filters,
        isDeactivated: isDeactivated,
        year: selectedYear.value,
      }),
    );
  };

  const handleFilterChange = ({ filters }) => {
    const filteredDetails = { ...filters, isApproved: true };
    console.log("filteredDetails", filteredDetails);
    dispatch(
      fetchMemberInfoList({
        entityId: activeEntity?._id,
        filters,
        isDeactivated: isDeactivated,
        year: selectedYear.value,
      }),
    );
  };
  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  const renderPaymentStatus = (item, month) => {
    const filteredData = item?.payments?.filter(
      (payment) => payment.month === month,
    );
    if (filteredData?.length > 0) {
      return (
        <div key={month} style={{ display: "flex" }}>
          {filteredData.map((payment) => {
            let color = "";
            let tooltipColor = "";

            switch (payment.status) {
              case "FAILED":
                color = "red-color";
                tooltipColor = "#FE4646";
                break;
              case "MISSED":
                color = "red-color";
                tooltipColor = "#FE4646";
                break;
              case "PENDING":
                color = "orange-color";
                tooltipColor = "#FFA500";
                break;
              case "PROCESSING":
                color = "yellow-color";
                tooltipColor = "#FFD700";
                break;
              case "SUCCESS":
                color = "green-color";
                tooltipColor = "#33BD72";
                break;
              case "REFUND":
                color = "refd-color";
                tooltipColor = "violet";
                break;
              case "REVERSAL":
                color = "refd-color";
                tooltipColor = "violet";
                break;
              default:
                break;
            }

            if (
              (userType === "admin" || userType === "viewer") &&
              payment.isOfflineUpdate &&
              payment.status === "SUCCESS"
            ) {
              color = "blue-color";
              tooltipColor = "#6FA8DC";
            }

            return (
              <Tooltip
                key={payment._id}
                title={
                  <div>
                    <strong>{t("Payment Status")}</strong>
                    <div>
                      <span style={{ color: tooltipColor }}>●</span>{" "}
                      {t(capitalizeFirstLetter(payment.status))}
                    </div>
                  </div>
                }
              >
                <Box className={color} />
              </Tooltip>
            );
          })}
        </div>
      );
    } else {
      return <Box ml="7px">{"-"}</Box>;
    }
  };
  const statusColors = [
    {
      name: t("Successful ( Online)"),
      status: "SUCCESS",
      color: "green-color",
    },
    { name: t("Successful (Offline)"), status: "SUCCESS", color: "blue-color" },
    { name: t("Failed"), status: "FAILED", color: "red-color" },
    { name: t("Processing"), status: "PROCESSING", color: "yellow-color" },
    { name: t("Pending"), status: "PENDING", color: "orange-color" },
    { name: t("Refund/Reversal"), status: "REFUND", color: "refd-color" },
    // { name: t(''), status: 'REVERSAL', color:'refd-color' }
  ];
  const handleChangeFilter = (val) => {
    const { filters } = val;
    let updatedFilters = { ...filters };
    updatedFilters[val.key_name] = val.value;
    updatedFilters.value = val.value;
    setFilters(updatedFilters);
    handleFilterChange({
      pageNum: 1,
      filters: updatedFilters,
    });
  };

  const handleSetUser = (id) => {
    let newUser = { ...selectedUsers };
    newUser[id] = !newUser[id] ? 1 : 0;
    setSelectedUser(newUser);
  };

  const showMemberDetails = (item, val = true) => {
    console.log("item???????", item);
    dispatch(setMemberDetailsVisible(item, val));
    setIsMemberModalVisible(val);
    if (item?.country) {
      dispatch(fetchCities(item?.country));
    }
  };

  const handleRecurringType = (item, isMonthly, isYearly) => {
    if (isMonthly && isYearly) {
      return (
        item.activeSubscription?.recurring_type === "monthly" ||
        item.activeSubscription?.recurring_type === "yearly"
      );
    } else if (isYearly) {
      return item.activeSubscription?.recurring_type === "yearly";
    } else if (isMonthly) {
      return item.activeSubscription?.recurring_type === "monthly";
    } else {
      return null;
    }
  };

  const getUserName = (truncattedName, formattedName, item) => {
    return (
      <div onClick={() => showMemberDetails(item)}>
        <h6
          style={{
            cursor: "pointer",
            fontWeight: "600",
          }}
          title={item?.name || "NA"}
          onMouseOver={(e) => (e.target.title = formattedName)}
          onMouseOut={(e) =>
            (e.target.title = item?.name
              ? truncate(item?.name, { length: 20 })
              : "NA")
          }
        >
          {truncattedName}
        </h6>
        <div style={{ display: "flex" }}>
          <div>
            {!item?.isMobileOnBoarded && (
              <small
                style={{
                  color: "#5D4037",
                  background: "#5D40371A",
                  borderRadius: "4px",
                  padding: "2px 4px",
                  marginRight: "8px",
                }}
              >
                {t("Offline")}
              </small>
            )}
          </div>
          <div>
            {item?.paymentMode === null && (
              <small
                style={{
                  color: "#D81B60",
                  background: "#D81B601A",
                  borderRadius: "4px",
                  padding: "0px 4px",
                  marginRight: "8px",
                }}
              >
                {t("Free")}
              </small>
            )}
          </div>
          <div>
            {item.activeSubscription?.recurring_type && item.paymentMode && (
              <small
                style={{
                  color:
                    item.activeSubscription?.recurring_type === "yearly"
                      ? "#FF5722"
                      : item.activeSubscription?.recurring_type === "monthly"
                      ? "#4763E4"
                      : "",
                  background:
                    item.activeSubscription?.recurring_type === "yearly"
                      ? "#FFEFE9"
                      : item.activeSubscription?.recurring_type === "monthly"
                      ? "#E3F2FD"
                      : "",
                  borderRadius: "4px",
                  padding: "2px 4px",
                  marginRight: "8px",
                }}
              >
                {capitalizeFirstLetter(
                  item.activeSubscription?.recurring_type || "",
                )}
              </small>
            )}
          </div>
          {item?.paymentMode && (
            <div>
              <small
                style={{
                  color:
                    item?.paymentMode === "manual"
                      ? "#673AB7"
                      : item?.paymentMode === "automatic"
                      ? "#00AC4F"
                      : "",
                  background:
                    item?.paymentMode === "manual"
                      ? "#F2E9FE"
                      : item?.paymentMode === "automatic"
                      ? "#E5F7ED"
                      : "",
                  borderRadius: "4px",
                  padding: "2px 4px",
                }}
              >
                {item?.paymentMode === "manual" ? t("Manual") : null}
                {item?.paymentMode === "automatic" ? t("Automatic") : null}
              </small>
            </div>
          )}
        </div>
      </div>
    );
  };

  const col2 = (truncattedName, formattedName, item) => {
    switch (true) {
      case columns?.showMosqueName:
        return (
          <div>
            <h6
              style={{ fontWeight: "600" }}
              className="mosque-info-name"
              title={item?.entity?.name || "NA"}
              onMouseOver={(e) => (e.target.title = item?.entity?.name)}
              onMouseOut={(e) =>
                (e.target.title = item?.entity?.name
                  ? truncate(item?.entity?.name, { length: 15 })
                  : "NA")
              }
            >
              {item?.entity?.name || "NA"}
            </h6>
          </div>
        );

      case columns?.showUsername:
        return getUserName(truncattedName, formattedName, item);
      default:
        return null;
    }
  };
  const col3 = (truncattedName, formattedName, item) => {
    switch (true) {
      case columns?.showMosqueName && columns?.showUsername:
        return getUserName(truncattedName, formattedName, item);
      default:
        return null;
    }
  };

  const renderMemberList = (isDeactivated, paymentStatus) => {
    if (sortedMemberList?.length == 0) {
      return null;
    }
    const startingSerialNumber = isSearch
      ? 1
      : (customerPageNum - 1) * customerPageSize + 1;
    return sortedMemberList
      .filter(
        (item) =>
          item.isApproved === true &&
          (paymentStatus
            ? Array.isArray(item.payments) &&
              item.payments.length > 0 &&
              item.paymentMode !== null
            : Array.isArray(item.payments)) &&
          (isDeactivated === null || item.isDeactivated === isDeactivated) &&
          (isMonthly || isYearly
            ? handleRecurringType(item, isMonthly, isYearly)
            : item),
      )
      .map((item, index) => {
        const currentIndex = startingSerialNumber + index; // Calculate current serial number
        const formattedName = (() => {
          if (!item?.name) {
            return "NA";
          }
          const nameParts = item.name.split(","); // Split by comma
          return nameParts.length > 1
            ? `${nameParts[1].trim()}, ${nameParts[0].trim()}` // lname, fname → fname lname
            : item.name;
        })();
        const truncattedName = truncate(formattedName, { length: 20 });
        const entity = item;
        return [
          currentIndex,
          columns?.showMosqueName || columns.showUsername ? (
            col2(truncattedName, formattedName, entity)
          ) : (
            <div></div>
          ),
          columns?.showMosqueName && columns?.showUsername ? ( // Column 3, only if both true
            col3(truncattedName, formattedName, entity)
          ) : (
            <div></div>
          ),
          renderPaymentStatus(item, 1),
          renderPaymentStatus(item, 2),
          renderPaymentStatus(item, 3),
          renderPaymentStatus(item, 4),
          renderPaymentStatus(item, 5),
          renderPaymentStatus(item, 6),
          renderPaymentStatus(item, 7),
          renderPaymentStatus(item, 8),
          renderPaymentStatus(item, 9),
          renderPaymentStatus(item, 10),
          renderPaymentStatus(item, 11),
          renderPaymentStatus(item, 12),
        ];
      });
  };

  const getConvertedMemberIds = () => {
    let member_subscriptions = [];
    for (const key in selectedUsers) {
      member_subscriptions.push(key);
    }
    return member_subscriptions;
  };

  const sendReminder = async () => {
    let members = getConvertedMemberIds();
    if (members.length > 0) {
      dispatch(
        sendMemberReminders({
          entity_id: activeEntity?._id,
          members,
        }),
      );
    } else {
      showNotification("error", "Please Select Users");
    }
  };

  const hasAttributeWithValueOne = Object.values(selectedUsers).some(
    (value) => value === 1,
  );

  const handleRedirection = () => {
    window.location.href = `/mosque/${activeEntity?._id}/info`;
  };

  const handleOnClick = () => {
    if (Object.keys(selectedUsers)?.length === memberInfoCount) {
      setSelectedUser({});
    } else {
      setSelectedUser({});
      let newUser = {};
      memberList.map((item) => {
        newUser[item?._id] = !newUser[item?._id] ? 1 : 0;
      });
      setSelectedUser(newUser);
    }
  };

  const isAllAttributesSetToOne = () => {
    if (Object.keys(selectedUsers)?.length === memberInfoCount) {
      return !!Object.keys(selectedUsers).length
        ? Object.values(selectedUsers).every((value) => value === 1)
        : false;
    }
    return false;
  };

  // Serach Method- Key Press
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      setIsSearch(true);
      // const filteredDetails = { ...filters, isApproved: true };
      const filteredDetails = {};
      filteredDetails.qtext = qtext;
      dispatch(updatePageForMemberInfoList(1));
      dispatch(
        fetchMemberInfoList({
          entity_id: activeEntity?._id,
          pageSize: customerPageSize,
          pageNum: customerPageNum,
          filters: filteredDetails,
          year: selectedYear.value,
          isDeactivated: isDeactivated,
        }),
      );
    }
  };

  // Search Method- CTA
  const handleButton = (val) => {
    if (val === "") {
      setIsSearch(false);
      if (activeEntity?._id) {
        const filteredDetails = {};
        // const filteredDetails = { ...filters, isApproved: true };
        dispatch(
          fetchCustomerInfoList({
            entity_id: activeEntity?._id,
            pageSize: customerPageSize,
            pageNum: customerPageNum,
            filters: filteredDetails,
            year: selectedYear?.value,
          }),
        );
      }
    }
    setValue(val);
  };

  const onChangeMosqueFilters = (selection) => {
    let updatedFilters = {};
    setValue("");
    const ids = selection.map((option) => Object.values(option)[0]);
    if (ids.length > 5) {
      alert(" You can only select 5 mosques..");
    }
    if (ids.length > 0) {
      setFilters({ ...filters, entityIds: [...ids] });
      setMosqueFilters({ ...filters, entityIds: [...ids] });
    } else {
      setFilters({ ...filters, entityIds: "" });
      setMosqueFilters({ ...filters, entityIds: "" });
    }
  };

  console.log(filters);

  // Filters Options
  const onCheckboxChange = (selection) => {
    let updatedFilters = {};
    setFilters({ ...filters, ...selection });
    const payment_statuses_data = selection.filter((item) => item["status"]);
    const payment_mode_data = selection.filter((item) => item["paymentMode"]);
    const recurring_type_data = selection.filter(
      (item) => item["recurring_type"],
    );
    const member_statuses_data = selection.filter(
      (item) => item["isDeactivated"],
    );

    if (payment_statuses_data.length > 0) {
      setpaymentStatus(true);
      console.log(
        "Selection of payment status boolean value will be set to: true",
      );
    } else {
      setpaymentStatus(false);
      console.log(
        "Selection of payment status boolean value will be set to: false",
      );
    }

    const recurringTypes = recurring_type_data.map(
      (item) => item.recurring_type,
    );
    setIsMonthly(recurringTypes.includes("monthly"));
    setIsYearly(recurringTypes.includes("yearly"));
    if (!!payment_statuses_data?.length) {
      updatedFilters["status"] = payment_statuses_data.map(
        (item) => item.status,
      );
    }
    if (!!payment_mode_data?.length) {
      updatedFilters["paymentMode"] = payment_mode_data.map(
        (item) => item.paymentMode,
      );
    }
    if (!!recurring_type_data?.length) {
      updatedFilters["recurring_type"] = recurring_type_data.map(
        (item) => item.recurring_type,
      );
    }
    if (!!member_statuses_data?.length) {
      updatedFilters["isDeactivated"] = member_statuses_data.map(
        (item) => item.isDeactivated,
      );
    }
    handleChangeFilter({
      pageNum: 1,
      filters: { ...mosqueFilters, ...selection },
    });
  };

  const tableclassName = infoPage
    ? `table-bg member-info-table pb-10`
    : "table-bg mosque-unpaid-table pb-4";

  const getStatusOption = [
    {
      label: "All",
      value: "all",
    },
    {
      label: "Active",
      value: "active",
    },
    {
      label: "Deactivated",
      value: "inactive",
    },
  ];

  const CustomDropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <img src={dropdownIcon} alt="dropdown" width={14} height={14} />
      </components.DropdownIndicator>
    );
  };

  // Method- Status Filter
  const handleStatusChange = (selectedOption) => {
    console.log("selected>>>>>>>>", selectedOption);
    if (selectedOption.value === "active") {
      // setIsCheckedActive(true);
      setIsDeactivated(false);
    } else if (selectedOption.value === "inactive") {
      // setIsCheckedActive(false);
      setIsDeactivated(true);
    } else {
      // setIsCheckedActive(false);
      setIsDeactivated(null);
    }
  };

  // Method- CSV Download
  const downloadCSV = async () => {
    try {
      setIsSendingEmail(true);
      const response = await fetch(csvDoUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ entityId: activeEntity?._id }),
      });

      if (!response.ok) {
        throw new Error("Failed to send  CSV via email");
      }

      showNotification("success", "CSV sent to email");
    } catch (error) {
      console.error("Error downloading CSV:", error);
      showNotification("error", "Failed to send  CSV via email");
    } finally {
      setIsSendingEmail(false);
    }
  };

  // Method- Sort By
  const handleSortBy = (selection) => {
    const sortedList = [...memberList].sort((a, b) => {
      if (selection === "Z-A") {
        const nameA = a.entity?.name ? a.entity?.name.toLowerCase().trim() : ""; // Handle empty names
        const nameB = b.entity?.name ? b.entity?.name.toLowerCase().trim() : "";
        return nameB.localeCompare(nameA);
      } else if (selection === "A-Z") {
        const nameA = a.entity?.name ? a.entity?.name.toLowerCase().trim() : ""; // Handle empty names
        const nameB = b.entity?.name ? b.entity?.name.toLowerCase().trim() : "";
        return nameA.localeCompare(nameB);
      } else if (selection === "latest") {
        const dateA = new Date(a.entity?.created_at);
        const dateB = new Date(b.entity?.created_at);
        return dateB - dateA;
      } else {
        const dateA = new Date(a.entity?.created_at);
        const dateB = new Date(b.entity?.created_at);
        return dateA - dateB;
      }
    });
    setSortedMemberList(sortedList);
  };

  // Fetch Entities- Owner
  const fetchEntitiesList = async () => {
    try {
      const inputData = {
        pageSize: 1000,
      };
      const entList = await callApiV2({
        method: "post",
        endpoint: "entity/entity-list",
        body: inputData,
      });

      setEntitiesList(entList?.data?.entityList);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (userType === "product_owner") {
      fetchEntitiesList();
    }
  }, [dispatch, activeEntity, filters]);

  console.log("page config", pageConfig);

  return (
    <>
      <div
        className={
          memberList.length >= 5
            ? tableclassName + " member-info-table-height-max"
            : tableclassName + " member-info-table-height-min"
        }
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          px="0px"
          py="28px"
          // className="gap-3"
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            className="gap-3"
          >
            <Label fontSize="22px" fontWeight={700}>
              {pageConfig?.title
                ? t(`${pageConfig?.title}`)
                : t("Member Information")}
            </Label>

            {
              <div style={{ width: "120px" }}>
                <Select
                  options={yearOptions}
                  value={selectedYear}
                  onChange={setSelectedYear}
                  placeholder={t("Select Year")}
                  isSearchable={false}
                  components={{
                    IndicatorSeparator: () => null, // 👈 removes black line
                  }}
                  styles={{
                    control: (base) => ({
                      ...base,
                      border: "1px solid #E7E7E7",
                      boxShadow: "none",
                      borderRadius: "10px",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: 500,
                      backgroundClip: "padding-box",
                      outline: "none",
                      // gap: "2rem",
                      "&:hover": {
                        borderColor: "#E7E7E7",
                      },
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      display: "flex",
                      justifyContent: "center",
                      paddingLeft: "12px", // keeps it visually balanced with arrow
                    }),
                    singleValue: (base) => ({
                      ...base,
                      padding: "0",
                      fontWeight: 500,
                    }),
                    input: (base) => ({
                      ...base,
                      visibility: "hidden",
                      width: 0,
                      height: 0,
                      paddingLeft: "10px",
                      margin: 0,
                    }),
                    indicatorsContainer: (base) => ({
                      ...base,
                      backgroundColor: "transparent",
                      borderRight: "none",
                    }),
                    option: (base, { isFocused, isSelected }) => ({
                      ...base,
                      backgroundColor: isSelected
                        ? "#f0f0f0"
                        : isFocused
                        ? "#f9f9f9"
                        : "white",
                      color: "#000000",
                      cursor: "pointer",
                      zIndex: "99999",
                      paddingRight: "20px",
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                  menuPortalTarget={document.body}
                />
              </div>
            }

            <div className="active-inactive">
              <Label
                className="block"
                style={{
                  backgroundColor: "#FFFFFF",
                  borderRadius: "10px",
                  cursor: "pointer",
                  border: "1px solid #E7E7E7",
                }}
              >
                <span
                  className="px-2 pr-0"
                  style={{
                    color: "#7E7E7E",
                    paddingTop: "8px",
                    paddingBottom: "8px",
                    fontSize: "14px",
                    fontWeight: "400",
                  }}
                >
                  {t("Status")} :
                </span>
                <Select
                  options={getStatusOption}
                  defaultValue={getStatusOption[1]}
                  onChange={handleStatusChange}
                  components={{
                    DropdownIndicator: CustomDropdownIndicator,
                    IndicatorSeparator: () => null, // removes the vertical separator line
                  }}
                  isSearchable={false}
                  menuPortalTarget={document.body}
                  styles={{
                    control: (base) => ({
                      ...base,
                      border: "none",
                      boxShadow: "none",
                      borderRadius: "10px",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: isCheckedActive ? 600 : 500,
                      gap: "2rem",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      padding: 0,
                    }),
                    singleValue: (base) => ({
                      ...base,
                      padding: "0",
                      fontWeight: isCheckedActive ? 600 : 500,
                    }),
                    input: (base) => ({
                      ...base,
                      visibility: "hidden",
                      width: 0,
                      height: 0,
                      padding: 0,
                      margin: 0,
                    }),
                    option: (base, { isFocused, isSelected }) => ({
                      ...base,
                      backgroundColor: isSelected
                        ? "#f0f0f0"
                        : isFocused
                        ? "#f9f9f9"
                        : "white",
                      color: "#000000",
                      cursor: "pointer",
                      zIndex: "99999",
                      paddingRight: "20px",
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                />
              </Label>
            </div>
            {/* <UploadXls refetchCustomerList={refetchCustomerList} /> */}
            <div className="d-flex align-items-center gap-2"></div>
          </div>
          <Box className="d-flex justify-center items-center gap-3">
            {!isFilterBlocked ? (
              <BoxContainer
                style={{
                  width: "auto",
                  marginRight: "0px",
                  marginLeft: "0px",
                  backgroundColor: "#FFFFFF",
                  border: "1px solid #E7E7E7",
                  padding: "5px 12px",
                  height: "auto",
                }}
              >
                <CheckboxMenu
                  options={bizIndustryLinks}
                  value={filters}
                  onChange={onCheckboxChange}
                  minheight="280px"
                  height="280px"
                  showAppliedCount={true}
                />
              </BoxContainer>
            ) : null}
            {columns?.showMosqueName && entitiesList && (
              <BoxContainer>
                <CheckBoxFilterAndSearch
                  options={getEntityListNames()}
                  value={filters}
                  onChange={onChangeMosqueFilters}
                />
              </BoxContainer>
            )}
            <Searchbar
              className="px-4"
              value={qtext}
              setValue={(e) => handleButton(e.target.value)}
              placeholder={t("Search")}
              fontSize="12px"
              border="0px solid rgba(0,0,0,.08)"
              searchIcon
              backgroundColor="#F5F5F5"
              color="#7E7E7E"
              borderRadius="10px"
              paddingLeft="25px"
              
              position="relative"
              inputProps={{
                type: "search",
                onKeyPress: handleKeyPress,
              }}
            />
            {infoPage &&
            !!getStatus() &&
            getStatus()?.payment_status === "unpaid" ? (
              <Button
                type={hasAttributeWithValueOne ? "primary" : "outlineColor"}
                disabled={is_sending_reminder}
                onClick={() => sendReminder()}
                px="25px"
                minWidth="175px"
                minHeight="35px"
                ml="34px"
              >
                {is_sending_reminder ? t("Sending...") : t("Send Reminder")}
              </Button>
            ) : null}
            {pageConfig?.enableSendCSV && (
              <button
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "5px",
                  color: "#FFFFFF",
                  backgroundColor: isSendingEmail ? "#7e7e7e" : "#D0004B",
                  borderRadius: "656px",
                  padding: "0 12px",
                  fontWeight: "700",
                  fontSize: "14px",
                  border: "none",
                  cursor: "pointer",
                }}
                disabled={isSendingEmail}
                onClick={downloadCSV}
              >
                <img src={download} alt="download-icon" />
                {t("Send CSV via Email")}
              </button>
            )}
          </Box>
        </Box>
        <Box className="payment-status-info">
          <p className="m-0 title">{t("Payment Status")}:</p>
          {statusColors.map((item) => (
            <div className="payment-legends">
              <Box className={item.color} />
              {item.name}
            </div>
          ))}
        </Box>
        <Box border="1px solid #0000001a" borderRadius="6px" marginTop="15px">
          <Table
            gridTemplateColumnsHeader={
              columns?.showMosqueName
                ? "5% 13% 20% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5%"
                : "8% 25%  3% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5%"
            }
            gridTemplateColumnsBody={
              columns?.showMosqueName
                ? "5% 13% 20% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5%"
                : "8% 25%  3% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5%"
            }
            columns={TemplateTableData}
            data={renderMemberList(isDeactivated, paymentStatus)}
            isAll={isAllAttributesSetToOne()}
            onClickAll={() => handleOnClick()}
            fetching={isFetching}
            height="500px !important"
            noResultText={t("No results found")}
          />
        </Box>
        <DefaultModal
          show={isMemberModalVisible}
          onHide={() => showMemberDetails(null, false)}
          className="profile-modal"
          style={{ paddingRight: "0px", background: "blue" }}
          centered={false}
          showHeader={false}
          size=""
          showFooter={false}
        >
          <ProfileModal
            refetchCustomerList={refetchCustomerList}
            onHide={() => showMemberDetails(null, false)}
          />
        </DefaultModal>
      </div>
      <PaginationV2
        currentPage={customerPageNum}
        pageSize={customerPageSize}
        totalCount={memberInfoCount}
        onPageChange={onPageChange}
      />
      <Modal
        title={t("Instructions for Uploading")}
        open={infoModal}
        onCancel={() => setInfoModal(false)}
        footer={null}
      >
        <ul>
          <li>
            {t("Fields marked with an asterisk")} <strong>(*)</strong>{" "}
            {t("are mandatory and must be updated for all user data.")}
          </li>
          <li>
            <strong>{t("For Free Subscriptions:")}</strong>{" "}
            {t(
              "Payment mode should be selected as “none” and leave the Customer IBAN and Customer Account Holder Name fields empty.",
            )}
          </li>
          <li>
            <strong>{t("For Manual Subscriptions:")}</strong>{" "}
            {t(
              "Payment mode should be selected as “manual” and leave the Customer IBAN and Customer Account Holder Name fields empty.",
            )}
          </li>
          <li>
            <strong>{t("For Autopay Subscriptions:")}</strong>{" "}
            {t(
              "Payment mode should be selected as “automatic” and ensure the Customer IBAN and Customer Account Holder Name fields are filled with valid data.",
            )}
          </li>
        </ul>
      </Modal>
    </>
  );
}

export default MemberTable;
